export const isLeapYear = (year: string): boolean => {
  return Number(year) % 4 === 0 ? true : false;
};
